// make an array of string into enum like object: ['a', 'b'] => {'a': 'a', 'b': 'b'}
export const convertStringArrayToEnumLikeObject = <T extends readonly string[]>(
  arr: T,
): Record<T[number], T[number]> =>
  arr.reduce(
    (acc, d) => ({ ...acc, [d]: d }),
    {} as Record<T[number], T[number]>,
  );
